import { useEffect } from 'react'

import { clearDatadogUser, setDatadogUser } from './datadogRum'
import { DatadogRumUser } from './types'

export const useDatadogUser = (profile: DatadogRumUser) => {
  const userId = profile?.uuid
  const email = profile?.email

  useEffect(() => {
    if (!userId) {
      clearDatadogUser()

      return
    }

    setDatadogUser({
      id: userId,
      email
    })

    return () => {
      clearDatadogUser()
    }
  }, [userId, email])
}
